import { Box, Col, Text } from '@opendoor/bricks-next';
import { EntryComponent } from 'cms/entries/entries';
import { IFcThreeSteps } from 'declarations/contentful';

import { FCContentContainer, FCContentContainerWrapper } from './shared/FCLayout';

const StepCircle = ({ number }: { number: number }) => (
  <Box
    width={120}
    height={120}
    borderRadius="$full"
    style={{ borderColor: 'rgba(255,255,255,1)', borderWidth: 4 }}
    alignItems="center"
    justifyContent="center"
    $largerThanMD={{ width: 170, height: 170 }}
  >
    <Text
      tag="span"
      typography="$displaySmall"
      fontWeight="$regular"
      color="$contentInversePrimary"
      style={{ lineHeight: '1.2', fontWeight: 300 }}
      css={{
        fontSize: '64px !important',
        '@media (min-width: 1201px)': {
          fontSize: '105px !important',
        },
      }}
    >
      {number}
    </Text>
  </Box>
);

const StepCard = ({
  stepNumber,
  title,
  description,
}: {
  stepNumber: number;
  title: string;
  description: string;
}) => (
  <Col alignItems="center" gap="$12x" width="100%" maxWidth={326} flexShrink={1}>
    <StepCircle number={stepNumber} />
    <Col gap="$4x" $largerThanMD={{ gap: '$12x' }}>
      <Text
        tag="h3"
        $largerThanMD={{ typography: '$subheaderXsmall' }}
        typography="$labelLarge"
        color="$contentInversePrimary"
        textAlign="center"
      >
        {title}
      </Text>
      <Text
        tag="p"
        typography="$bodySmall"
        $largerThanMD={{ typography: '$bodyLarge' }}
        color="$contentInversePrimary"
        textAlign="center"
      >
        {description}
      </Text>
    </Col>
  </Col>
);

const RenderFCThreeSteps = (entry: IFcThreeSteps) => {
  const { fields } = entry;

  return (
    <FCContentContainerWrapper style={{ backgroundColor: '#051a44' }}>
      <FCContentContainer>
        <Col
          alignItems="center"
          justifyContent="center"
          py="$24x"
          gap="$30x"
          $largerThanMD={{ paddingVertical: '$40x' }}
        >
          <Col gap="$6x">
            <Text
              tag="h2"
              typography="$headerMedium"
              textAlign="center"
              color="$contentInversePrimary"
              $largerThanMD={{ typography: '$displayXsmall' }}
            >
              {fields.title}
            </Text>
            <Text
              tag="p"
              typography="$bodyMedium"
              textAlign="center"
              color="$contentInversePrimary"
              maxWidth={630}
              $largerThanMD={{
                typography: '$bodyXlarge',
              }}
            >
              {fields.subtitle}
            </Text>
          </Col>
          <Box
            flexDirection="column"
            width="100%"
            flex={1}
            $smallerThanLG={{
              gap: '$24x',
            }}
            alignItems="center"
            justifyContent="center"
            $largerThanSM={{ flexDirection: 'row', justifyContent: 'space-evenly' }}
          >
            <StepCard
              stepNumber={1}
              title={fields.step1Title}
              description={fields.step1Description}
            />
            <StepCard
              stepNumber={2}
              title={fields.step2Title}
              description={fields.step2Description}
            />
            <StepCard
              stepNumber={3}
              title={fields.step3Title}
              description={fields.step3Description}
            />
          </Box>
        </Col>
      </FCContentContainer>
    </FCContentContainerWrapper>
  );
};

const FCThreeSteps: EntryComponent<IFcThreeSteps> = {
  render: RenderFCThreeSteps,
};

export default FCThreeSteps;
